import { ScoresColumn } from "../scoresTable.types";

export const meanColumn: ScoresColumn = {
	id: "mean",
	isVisible: () => true,
	getHeader: () => ({ label: "Média", align: "center" }),
	getCell: (row) => ({ content: { type: "text", value: row.instrument_dimension?.description ?? "N/A" } }),
};
